<script setup lang="ts">
import CsButton from '@/components/ui/button/CsButton.vue'
import AccountKYCForm from '@/modules/account/components/AccountKYCForm.vue'
import { BrokerDetailActionType, useBrokerDetailStore } from '@/modules/broker/stores/broker.detail.store.ts'
import BrokerProfile from '@/modules/broker/views/BrokerProfile.vue'
import SubMemberList from '@/modules/broker/views/SubMemberList.vue'
import CommissionByBroker from '@/modules/contract/components/CommissionByBroker.vue'
import ConsultantRequestByBroker from '@/modules/contract/components/ConsultantRequestByBroker.vue'
import ContractListByBroker from '@/modules/contract/components/ContractListByBroker.vue'
import CustomerListByBroker from '@/modules/contract/components/CustomerListByBroker.vue'
import FlashOfferListByBroker from '@/modules/flashoffer/components/FlashOfferListByBroker.vue'
import TransactionByAccount from '@/modules/transaction/components/TransactionByAccount.vue'
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue'
import { Icon } from '@iconify/vue'
import { useConfirm } from 'primevue'
import { useToast } from 'primevue/usetoast'
import { computed, onMounted, ref } from 'vue'

const BrokerDetailStore = useBrokerDetailStore()
interface Props {
  id: number,
  isUpdate?: boolean
}
const confirm = useConfirm()
const props = defineProps<Props>()
const loadingSubmit = ref(false)
const toast = useToast()
const fetched = computed(() => {
  return BrokerDetailStore.accounts[props.id]?.action_type
})
const currentTab = ref('0')
const type = ref('')
const handleTabChange = (val: string | number) => {
  console.log(val, 'val');
  currentTab.value = val as string
}

const account = computed(() => {
  const found = BrokerDetailStore.accounts[props.id];

  if(found) return found.account
  return null
})

const requestFetchData = async () => {
  try{

    await BrokerDetailStore.fetchBrokerDetail(props.id)
  } catch (e) {

  }
}

onMounted(() => {
  requestFetchData()
})

const handleAction = async (action: 'approve' | 'reject', id: number) => {
  loadingSubmit.value = true;
  const res = action === 'approve'
    ? await BrokerDetailStore.approveBroker(id)
    : await BrokerDetailStore.rejectBroker(id);
  loadingSubmit.value = false;
  const isSuccess = res?.status === 200;
  const actionText = action === 'approve' ? 'Phê duyệt' : 'Từ chối';

  toast.add({
    severity: isSuccess ? 'success' : 'error',
    summary: isSuccess ? 'Success' : 'Rejected',
    detail: `${actionText} ${isSuccess ? 'thành công' : 'thất bại'}`,
    life: 3000
  });

  if (isSuccess) {
    setTimeout(() => {
      requestFetchData()
    }, 200);
  }
};

const handleSubmit = async (action: 'approve' | 'reject', id: number) => {
  type.value = action
  confirm.require({
    message: `Bạn có chắc chắn muốn ${action === 'approve' ? 'phê duyệt' : 'từ chối'} môi giới này không?`,
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => handleAction(action, id),
    reject: () => {}
  });
}

</script>

<template>
  <template v-if="BrokerDetailActionType.FETCHING === fetched">
    <Card>
      <template #content>
        <div class="flex gap-3">
          Đang tải dữ liệu <Icon icon="eos-icons:three-dots-loading" width="24" height="24" />
        </div>
      </template>

    </Card>
  </template>
  <template v-if="BrokerDetailActionType.FETCH_FAILED === fetched">
    <Card class="bg-red-300">
      <template #content>
        <div class="flex flex-col gap-3 items-center">
          <Icon icon="fluent-color:error-circle-16" width="50" />
          <span class="font-300 text-[16px]">Lỗi khi tải dữ liệu này</span>
        </div>
      </template>

    </Card>
  </template>
  <template v-if="BrokerDetailActionType.FETCHED === fetched">
    <Panel class="mb-5 pb-5">
      <template #header>
        <div class="flex items-center justify-between w-full">
          <h3 class="text-base font-semibold p-panel-title">Thông tin môi giới: [#{{ account?.code }}] {{ account?.full_name }}</h3>
          <AllowPerm perm="broker.approve" action="hide">
            <div class="flex gap-2 pl-4 ml-4" v-if="account?.processing_status === 'pending'">
              <!-- <button
                :class="['btn flex items-center gap-2', loadingSubmit ? 'btn-disabled' : 'btn-success']"
                @click="handleSubmit('approve', account?.id)"
                :disabled="loadingSubmit">
                <Icon icon="mdi:check-all" width="20" height="20" />
                <div :class="[loadingSubmit ? 'flex items-center gap-2' : '']">
                  Phê duyệt môi giới <Icon icon="eos-icons:three-dots-loading" width="24" height="24" v-if="loadingSubmit && type === 'approve'" />
                </div>
              </button> -->
              <CsButton
                type="button"
                :loading="loadingSubmit && type === 'approve'"
                :disabled="loadingSubmit"
                variant="success"
                icon="mdi:check-all"
                text="Phê duyệt môi giới"
                @click="handleSubmit('approve', account?.id)"
              />
              <!-- <button
                :class="['btn flex items-center gap-2', loadingSubmit ? 'btn-disabled' : 'btn-danger']"
                @click="handleSubmit('reject', account?.id)"
                :disabled="loadingSubmit">
                <Icon icon="healthicons:i-documents-denied" width="20" height="20" />
                <div :class="[loadingSubmit ? 'flex items-center gap-2' : '']">
                  Từ chối phê duyệt <Icon icon="eos-icons:three-dots-loading" width="24" height="24" v-if="loadingSubmit && type === 'reject'" />
                </div>
              </button> -->
              <CsButton
                type="button"
                :loading="loadingSubmit && type === 'reject'"
                :disabled="loadingSubmit"
                variant="danger"
                icon="healthicons:i-documents-denied"
                text="Từ chối phê duyệt"
                @click="handleSubmit('reject', account?.id)"
              />
            </div>
          </AllowPerm>
        </div>
      </template>
      <BrokerProfile :account="account" :is-update="isUpdate"/>
    </Panel>
    <Tabs :value="currentTab"
      scrollable
      @update:value="handleTabChange"
      >
      <TabList>
        <Tab value="0">Giới thiệu</Tab>
        <Tab value="1">Thông tin KYC</Tab>
        <Tab value="2">Cấp dưới trực tiếp</Tab>
        <Tab value="3">Yêu cầu tư vấn </Tab>
        <Tab value="4">Khách hàng đang chăm sóc</Tab>
        <Tab value="5">Flash Offer đang tham gia </Tab>
        <Tab value="6">Hợp đồng </Tab>
        <Tab value="7">Doanh thu và hoa hồng </Tab>
        <Tab value="8">Lịch sử giao dịch</Tab>
      </TabList>
      <TabPanels>
        <TabPanel value="0">
          <p class="m-0">
            {{ account?.bio || 'Không có giới thiệu' }}
          </p>
        </TabPanel>
        <TabPanel value="1">
          <AccountKYCForm :is-update="isUpdate" :account="account?.user" :current-tab="currentTab" />
        </TabPanel>
        <TabPanel value="2">
          <SubMemberList :account="account" :current-tab="currentTab"/>
        </TabPanel>
        <TabPanel value="3">
          <ConsultantRequestByBroker :account="account" :current-tab="currentTab"/>
        </TabPanel>
        <TabPanel value="4">
          <CustomerListByBroker :account="account" :current-tab="currentTab"/>
        </TabPanel>
        <TabPanel value="5">
          <FlashOfferListByBroker :account="account" :current-tab="currentTab"/>
        </TabPanel>
        <TabPanel value="6">
          <ContractListByBroker :account="account" :current-tab="currentTab"/>
        </TabPanel>
        <TabPanel value="7">
          <CommissionByBroker :account="account" :current-tab="currentTab"/>
        </TabPanel>
        <TabPanel value="8">
          <TransactionByAccount :account="account?.user" :current-tab="currentTab"/>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </template>
</template>

<style scoped>

</style>
